import styled from '@emotion/styled';
import { colors } from '@modernhealth/vital-foundation';

import { useLanguageCode } from '../hooks/useLanguageCode';

import { CircleOnDemandDuration } from './CircleOnDemandDuration';
import { CircleOnDemandLanguage } from './CircleOnDemandLanguage';

export const CircleOnDemandFauxVideoPlayer: React.FC<{
    name: string;
    thumb: string;
    seconds: number;
    languageCode?: string;
    externalLink: string;
}> = ({ thumb, seconds, languageCode, externalLink }) => {
    const userLanguageCode = useLanguageCode();
    const isDifferentLanguage = languageCode && languageCode !== userLanguageCode;

    return (
        <a href={externalLink} target="_blank" rel="noreferrer">
            <Container>
                {isDifferentLanguage ? (
                    <CircleOnDemandLanguage languageCode={languageCode} />
                ) : null}
                <Thumbnail src={thumb} alt="" />
                <PlayButtonContainer>
                    <span css={{ textAlign: 'center', color: colors.gray65, fontSize: '20px' }}>
                        ▶
                    </span>
                </PlayButtonContainer>
                <CircleOnDemandDuration seconds={seconds} />
            </Container>
        </a>
    );
};

const Container = styled.div({
    display: 'flex-inline',
    flexDirection: 'column',
    position: 'relative',
    width: 560,
});

const Thumbnail = styled.img({
    width: '100%',
    objectFit: 'cover',
    borderRadius: 6,
});

const PlayButtonContainer = styled.div({
    position: 'absolute',
    borderRadius: '50%',
    backgroundColor: colors.white,
    width: 60,
    height: 60,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});
